export default {
  '测试记录列表':'Test Record List',
  '视频不存在':'The video does not exist.',
  '测试记录':'Test Record',
  '此记录暂无报告':'There is currently no report for this record',
}